import getObjectPathProperty from "./getObjectPathProperty";
import setResultInObjectByPath from "./setResultInObjectByPath";

export class PromiseWorker {

    constructor(apiAxios, requests, eventBus, context) {
        this.apiAxios = apiAxios;
        this.requests = requests;
        this.eventBus = eventBus;
        this.context = context;
    }

    replaceUrlParams(url, params) {
        if (params instanceof Object) {
            return url.replace(/{(.*?)}/g, (_, key) => params[key]);
        }
        return url;
    }

    executeAsyncRequests(inParallel = true) {

        if (inParallel) {
            return this.executeRequestsInParallel();
        }

        return this.executeRequestsSequentially();
    }

    async executeRequestsSequentially() {

        for (const request of this.requests) {
            const urlRequest = this.replaceUrlParams(request.url, request.paramsUrl);

            if (request.requestName === null || request.requestName === '') {
                throw new Error(`"requestName" is mandatory in ${JSON.stringify(request)}`);
            }

            try {
                const config = {
                    method: request.method || 'GET',
                    url: urlRequest,
                    data: request.body ? request.body : undefined,
                };

                const response = await this.apiAxios(config);

                let errorText = '';
                this.resultProcessing(response, request, errorText);

                this.fillResultToContext(response, request);

                //this.fillStateLoading(request);

                this.sendEvent(request);

                return {...request, result: response.data, error: errorText !== '' ? errorText : null};
            } catch (error) {
                console.log(error);
                return {...request, result: null, error: this.getErrorText(error)};
            }
        }
        ;
    }


    async executeRequestsInParallel() {
        const promises = this.requests.map(async (request) => {
            const urlRequest = this.replaceUrlParams(request.url, request.paramsUrl);

            if (request.requestName === null || request.requestName === '') {
                throw new Error(`"requestName" is mandatory in ${JSON.stringify(request)}`);
            }

            try {
                const config = {
                    method: request.method || 'GET',
                    url: urlRequest,
                    data: request.body ? request.body : undefined,
                };

                const response = await this.apiAxios(config);

                let errorText = '';
                this.resultProcessing(response, request, errorText);

                this.fillResultToContext(response, request);

                //this.fillStateLoading(request);

                this.sendEvent(request);

                return {...request, result: response.data, error: errorText !== '' ? errorText : null};
            } catch (error) {
                console.log(error);
                return {...request, result: null, error: this.getErrorText(error)};
            }
        });
        return Promise.all(promises);
    }

    sendEvent(request) {
        if (this.eventBus && request.event && request.event !== '') {
            if (request.eventParams && typeof request.eventParams === 'object' && Object.keys(request.eventParams).length !== 0) {
                this.eventBus.$emit(request.event, request.eventParams);
            } else {
                this.eventBus.$emit(request.event);
            }
        }
    }

    fillResultToContext(response, request) {
        if (this.context && response.data && response.data.status && response.data.status === 'operation_success' && response.data.data) {
            setResultInObjectByPath(this.context, request.requestName, response.data.data)
        }
    }

    resultProcessing(response, request, errorText) {
        if (response && response.status && response.status === 'operation_fail') {
            if (response.message) {
                errorText = response.message;
            }
        }
    }

    getErrorText(error) {
        let errorText = '';
        if (getObjectPathProperty(error, 'response.data.message')) {
            errorText = error.response.data.message;
        } else if (error.message) {
            errorText = error.message;
        } else {
            errorText = JSON.stringify(error);
        }
        return errorText;
    }

    getErrorsResponses(results, outputRequestName = false) {
        let errorsList = [];
        if (results && Array.isArray(results)) {
            results.forEach(item => {
                if (item.error) {
                    let errText = '';
                    if (outputRequestName) {
                        errText = item.requestName + ': ' + item.error;
                    } else {
                        errText = item.error;
                    }
                    errorsList.push(errText);
                } else if (item.result && item.result.status && item.result.status === 'operation_fail') {
                    if (item.result.message) {
                        errorsList.push(item.result.message);
                    }
                }
            })
        }
        return errorsList;
    }

    fillStateLoading(request) {
        if (request.stateLoading && this.context) {
            if (getObjectPathProperty(this.context, request.stateLoading)) {
                const properties = request.stateLoading.split('.');
                let obj = this.context, lengthProp = properties.length - 1;
                for (let i = 0; i < lengthProp; i++) {
                    if (typeof obj[properties[i]] === 'object') {
                        obj = obj[properties[i]];
                    } else {
                        return;
                    }
                }
                if (obj !== undefined) {
                    //console.log(obj[properties[lengthProp]])
                    obj[properties[lengthProp]] = false;
                    //console.log(obj[properties[lengthProp]])
                }
            }
        }
    }

}
